import { Box, Button, Text } from '@mantine/core';
import { IconLock, IconPlus } from '@tabler/icons-react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import prettifiedLabel from '../constants/labelPrettifier';
import useAllowedActions from '../helpers/useAllowedActions';
import { setRequestedActionToUnlock, setSuggestSubscriptionAlert } from '../store/subscriptionSlice';

const NewElementButton = ({ title, label, onClick, restrictionKey, restrictedClick, disabled, ...rest }) => {
  const { domain } = useSelector((state) => state.domain);
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const isSuperAdmin = user.userRoles.some((role) => role.role === 'superAdmin');
  const { suggestSubscriptionModal } = useSelector((state) => state.subscription);

  const allowedActions = useAllowedActions(domain);

  const restricted =
    (restrictionKey &&
      allowedActions &&
      !allowedActions.has(restrictionKey) &&
      !allowedActions.has('*') &&
      !isSuperAdmin) ||
    disabled === true;

  useEffect(() => {
    if (restricted === true && !suggestSubscriptionModal) {
      dispatch(setRequestedActionToUnlock(restrictionKey));
    }
  }, [restricted, suggestSubscriptionModal, restrictionKey, dispatch]);

  useEffect(() => {
    dispatch(setSuggestSubscriptionAlert(restricted));
  }, [restricted, dispatch]);

  return (
    <Box data-tour="newElementBtn" display="inline-block">
      <Button
        size="sm"
        {...rest}
        className="btn-plus-image"
        disabled={disabled || (restricted && restrictedClick)}
        onClick={onClick}
      >
        <IconPlus width={16} />
        <Text ml="sm">
          {label ?? prettifiedLabel(title)}
          {restricted ? (
            <>
              {' '}
              <IconLock size={14} />
            </>
          ) : null}
        </Text>
      </Button>
    </Box>
  );
};

export default NewElementButton;
